import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Card, Modal } from 'react-bootstrap';
import NoPhoto from '../Medias/LibImages/no-image.svg';

import Photo1 from '../Medias/Photos/1657282225_0.jpg';
import Photo2 from '../Medias/Photos/Pic1.jpg';
import Photo3 from '../Medias/Photos/1711909790_0.png';
import Photo4 from '../Medias/Photos/1714240910_0.jpg';
import Photo5 from '../Medias/Photos/im1.jpg';
import Photo6 from '../Medias/Photos/news_20240819.jpg';
import Photo7 from '../Medias/Photos/FB28DAAC-CF2D-481E-A0E4-4925C777B843.jpg';
import Photo8 from '../Medias/Photos/123.jpg';
import Photo9 from '../Medias/Photos/91736DC9-E536-4E65-A064-FBDE22195A17.jpg';
import Photo10 from '../Medias/Photos/F85AE8DE-056B-4753-AD16-5E6287C5BF90_use.jpg';
import Photo11 from '../Medias/Photos/S__1269874.jpg';
import Photo12 from '../Medias/Photos/S__7585802.jpg';
import Photo13 from '../Medias/Photos/P8085206.jpg';
import Photo14_1 from '../Medias/News/2025-09-06_1.jpg';
import Photo14_2 from '../Medias/News/2025-09-06_2.jpg';
import Photo14_3 from '../Medias/News/2025-09-06_3.jpg';
import Photo15_1 from '../Medias/News/2025-10-19.png';

function SectionNews({ contents, hideTopic = false }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const mockup = [
    {
      name: <>
        {`On October 15-16, 2025, Saran Boonrak and Ploykamon Ruengchaisin had a unique opportunity to provide legal inputs to support and ensure fair regulation of the Carbon Capture Utilization and Storage (CCUS) industry and its related operational activities. We would like to express our sincere gratitude to the Thailand CCUS Alliance (TCCA) for this opportunity and for appointing our lawyers as members of the TCCA.`}
      </>,
      row_slug: '',
      row_value: Photo15_1
    },
    {
      name: <>
        {`On September 5th, 2025, our center had the privilege of supporting a knowledge-sharing session with staff from EGAT and its subsidiaries. Organized by the Association of Private Producers (API), the event took place at Parco Hotel Khaoyai. During the session, we extensively discussed how EGAT can, within legal boundaries, contribute to Thailand's energy transition and explore ways to leverage laws as a positive force.`}
        <br />
        <img src={Photo14_2} className='w-100 mt-3' />
        <img src={Photo14_3} className='w-100 mt-3' />
      </>,
      row_slug: '',
      row_value: Photo14_1
    },
    {
      name: `On the 25 of August 2025, Dr. Piti Eiamchamroonlarp with support from the PTA Energy Center gave a lecture to the legal staffs of the Secretariat of The House of Representatives in the training course on legal drafting and impact evaluation of law enforcement organized by King Prajadhipok's Institute. This session discussed and explored how outdated energy laws can contribute to corruption in the energy sector.`,
      row_slug: '',
      row_value: Photo13
    },
    {
      name: `On June 27, Supakarn and Preecha had the opportunity to attend the launch event of Attention Co., Ltd., a company focused on delivers cybersecurity and digital solutions for the government sector.`,
      row_slug: '',
      row_value: Photo12
    },
    {
      name: `On May 7, 2025, Supakarn and Saran had the opportunity to attend a seminar at Bitkub’s headquarters. A key highlight of the event was the discussion on the legal nature of tokenized carbon credits, renewable energy certificates, and carbon allowances. We were pleased to support this important event.`,
      row_slug: '',
      row_value: Photo11
    },
    {
      name: `On March 5th, Supakarn had a distinctive opportunity to assist Banpu Next in offering legal recommendations for practical and sustainable measures aimed at achieving a low-carbon island for the Koh Samui City Municipality Office. Our proposals extend beyond simple legal advice, emphasizing how legislation can act as a positive driver for the development of the "digital infrastructure" within a smart city.`,
      row_slug: '',
      row_value: Photo10
    },
    {
      name: `On February 27th, our legal analysis and practical insights regarding the potential roles of "Virtual Power Purchase Agreements" in enhancing the integration of EV charging with renewable energy were well-received at the keynote stage of the EV Charge Live Thailand 2025 event held at BITEC Bangkok. We are pleased to present these innovative legal solutions in our "Publications" section.`,
      row_slug: '',
      row_value: Photo9
    },
    {
      name: `This book explores the role and effectiveness of laws in facilitating energy transition for positive outcomes. It also examines the legal obstacles, or perceived legal obstacles, that hinder competition in Thailand's energy sector and affect the integration of renewable energy into the country's energy mix. It was launched at the 29th Book Expo on October 13, 2024.`,
      row_slug: '',
      row_value: Photo8
    },
    {
      name: `On October 7, 2024, Supakarn attended a meeting at the Tobacco Authority of Thailand (TOAT). Alongside Autrans Company Limited, our team contributed legal insights for the preparation and market analysis of the draft land rental and development contract. We wish TOAT great success in their upcoming series of land rent bidding.`,
      row_slug: '',
      row_value: Photo7
    },
    {
      name: `On August 16, 2024, Mr. Nontnawat Wattananont conducted a legal workshop focused on creating regulatory frameworks to limit the manufacturing and use of single-use plastic products, while also promoting eco-design for plastic packaging requirements in Thailand. His expertise in circular economy promotion law contributes significantly to the project titled "Marine Litter Prevention through Reduction, Sustainable Design, and Recycling of Plastic Packaging (MA-RE-DESIGN)."`,
      row_slug: '',
      row_value: Photo6
    },
    {
      name: `The Office of the Personal Data Protection Commission (PDPC) conducted an interactive seminar on 24th and 27th of May 2024, for PDPA/DPO trainers. A primary goal of this seminar was to equip trainers to consistently and accurately impart knowledge and practices regarding personal data protection and data security. Participants who actively engaged in this seminar and met the requirements will be recognized by the PDPC as certified PDPA and DPO trainers.`,
      row_slug: '',
      row_value: Photo2
    },
    {
      name: `On the 5th of July, Dr. Tanatthep Tianprasit, our Partner, joined a public seminar re: "Marketing in the Data Privacy Era". The event was jointly organized by SB Telecom (Thailand), D-Serve Consulting, ADA Thailand, and Treasure Data. We are delighted to use this opportunity to share a hard copy version of our recent pubication -" Q&A Book on PDPA for Practioners" (first edition) to Miss Nunramon Tangchitaree, Chief Executive Officer, D-Serve Consulting.`,
      row_slug: '',
      row_value: Photo1
    },
    {
      name: `PT & Associates provided guidance to Super Energy Group Public Co. Ltd. (SEG) regarding its merger and acquisition proposal, which was submitted to the Energy Regulatory Commission (ERC) in accordance with the Energy Industry Act 2007 and the relevant ERC Notifications and Guidelines. The ERC approved the proposal on 21st of February 2024. According to the ERC, this transaction will support SEG and its subsidiaries in their investment and strategic endeavors. Importantly, it was found that this merger will not impede competition in electricity generation markets nor create barriers to entry for other energy operators.`,
      row_slug: '',
      row_value: Photo3
    },
    {
      name: `On the 24th of April 2024, our team had a very unique opportunity to discuss and share our legal analysis on a Low Carbon Destination Island project with Koh Samui City Municipality Office. This exciting project involves distributed green electricity generation, sustainable water supply, and circular economy business models.`,
      row_slug: '',
      row_value: Photo4
    },
    {
      name: `On June 18, 2024, PT & Associates, along with a team of city planning and development experts, supported the Tobacco Authority of Thailand (TAT) in orchestrating a market sounding event. The purpose was to gauge the interest of investors and developers in renting TAT's lands in Bangkok and Chiang Rai. Our role encompassed presenting proposals concerning contractual frameworks for land use and rental fees. This event signifies a shift in TAT's business model, transitioning from solely being a tobacco producer to becoming a land lessor, thus signaling its entry into the real estate market.`,
      row_slug: '',
      row_value: Photo5
    },
  ];

  const handleViewContent = (name, content, image) => {
    setSelectedContent(content);
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContent(null);
    setSelectedImage(null);
  };

  return (
    <section id="article" className="pt-5 pb-0">
      <Container className='pt-0 pb-0'>
        {hideTopic ? null :
          <h1 className='font-header text-center mb-5'>News & Events</h1>
        }
        <Row>
          {mockup.map((item, index) => (
            hideTopic || index < 6 ?
              <Col sm={12} md={4} key={index}>
                <Card className='w-100 border-0 rounded-0 mb-5'>
                  <div className="bg-img ratio-16x9" style={{ backgroundImage: `url(${item.row_value})` }}></div>
                  <Card.Title className='font-default w-100 p-3 px-4 m-0 fw-normal tx-color-primary'>
                    <button
                      className='btn tx-color-primary text-decoration-none text-start p-0'
                      onClick={() => handleViewContent(item.name, item.name, item.row_value)}
                    >
                      <p className='line-clamp-3'>{item.name}</p>
                    </button>
                  </Card.Title>
                </Card>
              </Col>
              : null
          ))}
        </Row>
        {!hideTopic ?
          <Row>
            <Col className='text-center'>
              <Button as={Link} to='/NewsAndEvents' className='px-5 bg-white tx-color-primary fw-bold border-1' style={{ borderColor: 'var(--color-primary)' }}>
                View More
              </Button>
            </Col>
          </Row>
          : null}

        {/* Modal for Content */}
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Body className='p-4'>
            {/* <img src={selectedImage} alt="News" className="w-100 mb-3" style={{ maxHeight: '400px', objectFit: 'cover' }} /> */}
            <img src={selectedImage} alt="News" className="w-100 mb-3" />
            <p>{selectedContent}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </section>
  );
}

SectionNews.defaultProps = {
  contents: []
};

export default SectionNews;
